
import React, { useEffect, useState, useRef } from 'react';
import styles from './profilePicDropDown.module.css';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import MyProfile from '../MyProfile/MyProfile.jsx';
import { axiosInstance } from '../../../lib/axiosInstance.js';
import { useAuth } from '../../global_state_components/AuthProvider.jsx';
import { useNavigate } from 'react-router-dom';

function ProfilePicDropDown(props){
  const { isAuthenticated, setIsAuthenticated} = useAuth();    //Defined in AuthProvider.jsx
  const {profilePicRef, isMobile, setShowProfilePicDropDown, setShowMyProfile, setShowNotification, setShowSettings} = useGlobalState();
  const navigate = useNavigate();

  //------------------Handle clickoutside to close friends list-------------------
  const showProfilePicDropDownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showProfilePicDropDownRef.current && !showProfilePicDropDownRef.current.contains(event.target) && !profilePicRef.current.contains(event.target)) {  //(if the reference element is active I guess) and (if the reference element is not clicked)
        // Clicked outside the component
        //console.log('Clicked outside!');
        setShowProfilePicDropDown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);      //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);   //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
    };
  }, []);







  //-----Handle logout------- 
  const handleLogout = async () => {
    try {
      
      await axiosInstance.get('/auth/logout');
      setIsAuthenticated('unauthenticated');
      setShowProfilePicDropDown(false);

      //console.log("logout");
      //localStorage.setItem('category', 'silent_study');
      
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  //-----Getting profile name------- 
  const [name, setName] = useState('');
  const [version, setVersion] = useState('Free');
  useEffect(()=>{
    async function getName() {
      try {
        const  response = await axiosInstance.get('/profile');
        setName(response.data.name);
        //setVersion(response.data.version);
      } catch (error) {
        if (error.response) {
          // Server responded with a status other than 200 range
          console.log("Error Data: ", error.response.data);
          console.log("Error Status: ", error.response.status);
          console.log("Error Headers: ", error.response.headers);
        } else if (error.request) {
          // Request was made but no response was received
          console.log("Error Request: ", error.request);
        } else {
          // Something else happened
          console.log("Error Message: ", error.message);
        }
      }
    }
    getName();
  },[])


  return(
    <div ref={showProfilePicDropDownRef} className={styles.main_div}>
      <div className={styles.name_div}>
        <div className={styles.name}>{name}</div>
        <div className={styles.version}>({version})</div>
      </div>
        
      <hr></hr>

      <div className={styles.menu_div}>
        <div onClick={()=>{setShowMyProfile(prev=>!prev)}}>Profile</div>    {/*My profile*/}
        <div onClick={()=>{setShowNotification(prev=>!prev)}}>Notifications</div>
        <div onClick={()=>{setShowSettings(prev=>!prev)}}>Settings</div>
        <div onClick={handleLogout}>Logout</div>
      </div>
    </div>
  )
}

export default ProfilePicDropDown;